import { css } from '@emotion/react';

export const cssReset = css`
  font-family: var(--bxp-charlie-text-font-family);

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--bxp-charlie-display-font-family);
  }

  input {
    font-family: var(--bxp-charlie-text-font-family);
  }
`;
